module.exports = __webpack_public_path__ + "img/electric_enabled.d8196e8c.svg";